import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/landing/rebuild";

export { errorMessage };

/**
 * Whether a rebuild is queued, when it fires, and how the last one went.
 *
 * Every judgement here is the API's: the quiet window, the clock the due time
 * is measured against, and whether this environment builds at all. The panel
 * renders the answer and computes none of it — the browser's clock is not the
 * one the cron runs on.
 */
export const fetchRebuildStatus = () => ApiService.request(ROOT, "get");

/**
 * Start a build now, skipping the quiet window.
 *
 * A 409 is not a failure: it is the API saying this environment declines to
 * build — no token, or rebuilds deliberately off — and carrying the sentence
 * that explains why. Axios rejects on 409, so it is unwrapped back into an
 * ordinary result. Left alone, a deliberate refusal reaches the screen as a
 * red error toast, which is the one confusion this panel exists to prevent.
 */
export const triggerRebuild = async () => {
  try {
    return await ApiService.request(ROOT, "post");
  } catch (error) {
    const declined = error?.response?.status === 409 ? error.response.data?.data : null;
    if (!declined) throw error;
    return declined;
  }
};
